import { combineReducers } from "@reduxjs/toolkit";

import latest from "./latest/slice";
import details from "./details/slice";

export default combineReducers({
  latest,
  details,
});
